/** Builds the copy key getter of a section: `const getCopyKey = createCopyKey('logged_out_homepage.faqs')`. */
export const createCopyKey = (prefix: string) => (path: string) => `${prefix}.${path}`;
